import React from 'react';
import PropTypes from 'prop-types';
import Markdown from 'react-markdown';

import './faq.scss';

const Faq = ({ question, answer }) => (
  <div className="faq">
    <h3 className="faq__question">
      {question}
    </h3>
    <div className="faq__answer">
      <Markdown>{answer}</Markdown>
    </div>
  </div>
);

Faq.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
};

export default Faq;



// WEBPACK FOOTER //
// ./src/components/Faqs/Faq/index.jsx